import { jsx, jsxs } from "react/jsx-runtime";
import { Tabs as f } from "../../node_modules/@zillow/constellation-10/dist/components/tabs/tabs.esm.js";
import { omitUndefined } from "../../utils/lodash.esm.js";
import { LOAN_PROGRAMS } from "../../utils/zhl-calculator.esm.js";
import CalculatorForm from "../CalculatorForm/CalculatorForm.esm.js";
import CalculatorLayout from "../CalculatorLayout/CalculatorLayout.esm.js";
import { handleFieldClickEvent } from "./AmortizationCalculator.Clickstream.esm.js";
import { FieldConfig, RFC_2822_MONTHS, TERM_TO_RATE } from "./AmortizationCalculator.utils.esm.js";
import AmortizationFields from "./AmortizationFields.esm.js";
import AmortizationLineChart from "./AmortizationLineChart.esm.js";
import AmortizationPaymentSummary from "./AmortizationPaymentSummary.esm.js";
import AmortizationScheduleTable from "./AmortizationScheduleTable.esm.js";
const AmortizationCalculator = ({
  defaultValues,
  editorMode
}) => {
  const finalDefaultValues = {
    [FieldConfig.amount.name]: 2e5,
    [FieldConfig.term.name]: LOAN_PROGRAMS.fixed30Year,
    [FieldConfig.rate.name]: TERM_TO_RATE.Fixed30Year.rate,
    [FieldConfig.startMonth.name]: RFC_2822_MONTHS[(/* @__PURE__ */ new Date()).getMonth()],
    [FieldConfig.startYear.name]: (/* @__PURE__ */ new Date()).getFullYear(),
    ...omitUndefined(defaultValues)
  };
  return /* @__PURE__ */ jsx(CalculatorForm, { fieldStorageKey: "amortizationfields", defaultValues: finalDefaultValues, editorMode, children: /* @__PURE__ */ jsx(CalculatorLayout, { fields: /* @__PURE__ */ jsx(AmortizationFields, {}), content: /* @__PURE__ */ jsxs(f.Root, { defaultSelected: "payment", children: [
    /* @__PURE__ */ jsxs(f.List, { "aria-label": "Amortization calculator tabs", children: [
      /* @__PURE__ */ jsx(f.Tab, { value: "payment", id: "payment", "aria-controls": "payment-panel", type: "button", onClick: () => handleFieldClickEvent("Payment", "tab"), children: "Payment" }),
      /* @__PURE__ */ jsx(f.Tab, { value: "chart", id: "chart", "aria-controls": "chart-panel", type: "button", onClick: () => handleFieldClickEvent("Chart", "tab"), children: "Chart" }),
      /* @__PURE__ */ jsx(f.Tab, { value: "schedule", id: "schedule", "aria-controls": "schedule-panel", type: "button", onClick: () => handleFieldClickEvent("Schedule", "tab"), children: "Schedule" })
    ] }),
    /* @__PURE__ */ jsx(f.Panel, { value: "payment", id: "payment", "aria-labelledby": "payment", children: /* @__PURE__ */ jsx(AmortizationPaymentSummary, {}) }),
    /* @__PURE__ */ jsx(f.Panel, { value: "chart", id: "chart", "aria-labelledby": "chart", children: /* @__PURE__ */ jsx(AmortizationLineChart, {}) }),
    /* @__PURE__ */ jsx(f.Panel, { value: "schedule", id: "schedule", "aria-labelledby": "schedule", children: /* @__PURE__ */ jsx(AmortizationScheduleTable, {}) })
  ] }) }) });
};
export {
  AmortizationCalculator as default
};
